import React from 'react'

/**
 * Function for input with type="number" can using maxLength for input
 *
 * @param event
 * @param maxLength
 */

export const handleMaxLengthInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength: number,
) => {
  event.target.value = Math.max(0, parseInt(event.target.value))
    .toString()
    .slice(0, maxLength)
}

export const formatIdNumber = (value: number) => {
  const rounded = Math.round(value)
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const formatIdNumberCompact = (value: number) => {
  const abs = Math.abs(value)
  if (abs >= 1_000_000_000_000)
    return `${(value / 1_000_000_000_000).toFixed(1).replace(/\.0$/, '')}T`
  if (abs >= 1_000_000_000)
    return `${(value / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}M`
  if (abs >= 1_000_000)
    return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}Jt`
  if (abs >= 1_000)
    return `${(value / 1_000).toFixed(1).replace(/\.0$/, '')}Rb`
  return formatIdNumber(value)
}

export const handleDigitSeparator = (number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(number)
}
